import * as React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  Typography,
  Box,
  Container,
  TextField,
  CssBaseline,
  Button,
  Avatar,
  Select,
  MenuItem,
  IconButton,
  CircularProgress,
  Paper,
  FormControl,
  Tabs,
  Tab,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { connect } from "react-redux";
import { loginIMSAdmin, signUp } from "../../app/store/actions/authActions";
import {
  Navigate,
  NavLink,
  Route,
  Routes,
  useNavigate,
  useParams
} from "react-router-dom";
import {
  centered_flex_box,
  MainInput,
  MainInputLabel,
  MainPassword,
  main_button,
  StyledInput,
  MainPhone,
  sec_button,
  left_flex_box
} from "../../app/components/Styles";
import { isMobile } from "react-device-detect";
import { Image, Table, notification } from "antd";
import Logo from "../../app/components/logo.png";
import PropTypes from "prop-types";
import MuiPhoneNumber from "material-ui-phone-number";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import ImageComponent from "../../app/components/ImageComponent";
import { downloadProductsQRS, getProducts, getWarehouses, receiveInbound } from "../../app/store/actions/imsWarehouseStaffActions";
import { useEffect } from "react";
import { AddCircleOutline } from "@mui/icons-material";
import moment from "moment/moment";
import InboundsTable from "../../app/components/InboundsTable";
import { useState } from "react";
import { getRequest } from "../../core/network";
import QrReader from "modern-react-qr-reader"
import { isNumber } from "lodash";
import { clampFaultyQuantity, withFaultyFields } from "../../app/components/inboundFaultySplit";
import InboundFaultySplitFields from "../../app/components/InboundFaultySplitFields";

export const ReceiveInbounds = ({
  getProducts,
  getWarehouses,
  receiveInbound,
  user,
  token,
  warehouse,
  products,
  downloadProductsQRS,
  isLoading
}) => {
  const navigate = useNavigate();
  const { warehouseId } = useParams();
  const [inboundItemText, setInboundItemText] = useState("");
  const [inboundItemData, setInboundItemData] = useState({});
  const [inboundItems, setInboundItems] = useState({});
  const [gettingItem, setGettingItem] = useState(false);
  const [scanning, setScanning] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [relatedOrder, setRelatedOrder] = useState(null);
  const [shippingServiceToScan, setShippingServiceToScan] = useState(user?.shippingService?.service || "Bosta")
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [pendingQuantityUpdate, setPendingQuantityUpdate] = useState({ quantity: null, id: null });

  useEffect(() => {
    getWarehouses({ warehouseId })
    setSubmitted(false)
  }, [warehouseId])

  // useEffect(() => {
  //   if (Object.keys(inboundItemData).length > 0) {
  //     console.log("InboundItemData: ", inboundItemData)
  //     if (mongoose.Types.ObjectId.isValid(inboundItemData.inboundItemOrOrderId)) {
  //       return handleGetInboundItem()
  //     }
  //     if (inboundItemData.inboundItemOrOrderId) {
  //       console.log("By Order")
  //       return handleGetInboundItem()
  //     }
  //   }
  // }, [inboundItemData])

  const parseInboundInput = (value = "") => {
    // Try parsing as JSON first
    try {
      const json = JSON.parse(value);
      console.log("Parsed JSON:", json);
      if (!isNumber(json)) {
        return {
          uuid: json.uuid,
          inboundItemOrOrderId: json.inboundItemId || json.productId,
        };
      }
    } catch (err) {
      console.log("Failed to parse as JSON");
    }

    if (warehouse?.name.includes("Faulty") || warehouse?.name.includes("Returns")) {
      if (shippingServiceToScan.toLowerCase() === "shipblu") {
        const shipBluIdParts = value.split("-");
        if (shipBluIdParts.length >= 3 && shipBluIdParts[1].length >= 6 && !value.includes("{") && !value.includes("}")) {
          return { inboundItemOrOrderId: shipBluIdParts[1] };
        }
      } else if (shippingServiceToScan.toLowerCase() === "bosta") {
        const trimmedValue = value.trim();
        const is8Digits = /^\d{8}$/.test(trimmedValue);
        const is10Digits = /^\d{10}$/.test(trimmedValue);
        if (is10Digits || (is8Digits && scanning)) {
          return { inboundItemOrOrderId: trimmedValue };
        }
      } else if (shippingServiceToScan.toLowerCase() === "fincart") {
        const trimmedValue = value.trim();
        if (trimmedValue.length >= 6 && !value.includes("{") && !value.includes("}")) {
          return { inboundItemOrOrderId: trimmedValue };
        }
      }
    }

    return null;
  };

  const handleParseInput = (value) => {
    setInboundItemText(value)
    const parsedInput = parseInboundInput(value);
    if (parsedInput) {
      setInboundItemData(parsedInput);
    }
  };

  const handleGetInboundItem = (rawInputOverride) => {
    console.log("handleGetInboundItem Called")
    setGettingItem(true)
    const submittedInput = (typeof rawInputOverride === "string" ? rawInputOverride : inboundItemText)?.trim();
    const parsedSubmittedInput = submittedInput ? parseInboundInput(submittedInput) : null;
    const inboundItemId =
      parsedSubmittedInput?.inboundItemOrOrderId ||
      submittedInput ||
      inboundItemData.inboundItemOrOrderId;
    const uuid = parsedSubmittedInput?.uuid || inboundItemData.uuid;

    getRequest({ inboundItemId, uuid, warehouseId }, undefined, token, "IMAdmin/inbounds/items").then((response) => {
      const { data } = response
      const { item, items, relatedOrder } = data;
      let temp = inboundItems
      if (item) {
        if (Object.keys(temp).includes(item._id)) {
          if (inboundItemData.uuid && temp[item._id].uuids.includes(inboundItemData.uuid)) {
            return notification.error({ message: "Exact Item Already Scanned" })
          } else {
            if (temp[item._id].quantityReceived >= temp[item._id].maxQuantity) {
              return notification.error({ message: "Item Quantity Exceeded" })
            }
            temp[item._id].quantityReceived = temp[item._id].quantityReceived + 1
            temp[item._id].uuids.push(inboundItemData.uuid)
          }
        } else {
          temp[item._id] = { maxQuantity: item.quantity, quantityReceived: 1, _id: item._id, product: item.product, faultyQuantity: 0, uuids: [inboundItemData.uuid] }
        }
      } else {
        items.map((inboundItem) => {
          if (Object.keys(temp).includes(inboundItem._id)) {
            if (temp[inboundItem._id].quantityReceived >= temp[inboundItem._id].maxQuantity) {
              return notification.error({ message: "Item Quantity Exceeded" })
            }
            temp[inboundItem._id].quantityReceived = temp[inboundItem._id].quantityReceived + 1
          } else {
            temp[inboundItem._id] = { maxQuantity: inboundItem.quantity, quantityReceived: 1, _id: inboundItem._id, product: inboundItem.product, faultyQuantity: 0 }
          }
        })
      }

      if (relatedOrder) {
        setRelatedOrder(relatedOrder)
      }

      notification.success({ message: item ? "Fetched Item" : "Fetched Items" })
      console.log(temp)
      setInboundItems(temp)
      setInboundItemText("")
    }).catch((err) => { console.error(err); notification.error({ message: err.response?.data?.message || "Product Not Found" }) }).finally(() => {
      setGettingItem(false);
      setInboundItemData({});
    })
  }

  const applyQuantityReceived = (parsedQuantity, id) => {
    let temp = {}
    Object.assign(temp, inboundItems)
    temp[id].quantityReceived = parsedQuantity
    temp[id].faultyQuantity = clampFaultyQuantity(parsedQuantity, temp[id].faultyQuantity)
    setInboundItems(temp)
  }

  const updateItemQuantity = (quantity, id) => {
    const parsedQuantity = parseInt(quantity);
    
    // Check if quantity is greater than 100 and show confirmation dialog
    if (parsedQuantity >= 100) {
      setPendingQuantityUpdate({ quantity: parsedQuantity, id });
      setConfirmDialogOpen(true);
      return;
    }
    
    applyQuantityReceived(parsedQuantity, id)
  }

  const handleConfirmQuantityUpdate = () => {
    if (pendingQuantityUpdate.quantity && pendingQuantityUpdate.id) {
      applyQuantityReceived(pendingQuantityUpdate.quantity, pendingQuantityUpdate.id)
    }
    setConfirmDialogOpen(false);
    setPendingQuantityUpdate({ quantity: null, id: null });
  }

  const handleCancelQuantityUpdate = () => {
    setConfirmDialogOpen(false);
    setPendingQuantityUpdate({ quantity: null, id: null });
  }

  const updateItemFaultyQuantity = (faultyQuantity, id) => {
    let temp = {}
    Object.assign(temp, inboundItems)
    temp[id].faultyQuantity = clampFaultyQuantity(temp[id].quantityReceived, faultyQuantity)
    setInboundItems(temp)
  }

  const handleScan = (data) => {
    if (!scanning && !gettingItem && data) {
      setScanning(true)
      console.log(data)
      handleParseInput(data);
    }
  }

  const handleSubmit = () => {
    const itemUpdates = Object.values(inboundItems).map((item) =>
      withFaultyFields({
        _id: item._id,
        quantityReceived: item.quantityReceived,
        faultyQuantity: item.faultyQuantity,
        uuids: item.uuids,
        product: item.product,
        maxQuantity: item.maxQuantity,
      })
    )
    receiveInbound({ itemUpdates }, navigate)
    setSubmitted(true)
  }

  const handlePrintLabel = (product, quantity, vendor) => {
    const data = [{
      quantity: quantity,
      product: product,
      vendor: vendor,
    }]

    downloadProductsQRS({ items: data })
  }

  return (
    <div>
      <Box sx={{ width: "100%", padding: 5, mt: isMobile ? 0 : 2 }}>
        <Box sx={{ ...centered_flex_box, mb: 1 }}>
          <Typography variant='h4' sx={{ color: "var(--secColor)" }}>Receive Inbound Items</Typography>
          {/* <IconButton onClick={() => navigate("/ims/admin/orders/add")} sx={{ color: "var(--secColor)", mx: 2 }}><AddCircleOutline /></IconButton> */}
        </Box>
        <Box sx={{ ...centered_flex_box, mb: 1 }}>
          <Card sx={{ width: "100%" }}>
            {isMobile ? (<CardContent>
              <Box sx={{ padding: 1, ...centered_flex_box, flexDirection: "column" }}>
                <QrReader
                  onScan={handleScan}
                  style={{
                    height: 250,
                    width: 250,
                  }}
                  facingMode={"environment"}
                />
                <Button onClick={() => setScanning(false)} disabled={!scanning} sx={{ ...main_button, mt: 1 }}>Scan Again</Button>
              </Box>
            </CardContent>) : (<CardContent>
              <Box sx={{ ...left_flex_box }}>
                {(warehouse?.name.includes("Faulty") || warehouse?.name.includes("Returns")) && <MainInput
                  select
                  sx={{ marginInlineEnd: 2, minWidth: "20vw" }}
                  defaultValue={shippingServiceToScan}
                  label="Shipping AWB"
                  onChange={({ target }) => setShippingServiceToScan((target.value))}
                >
                  <MenuItem value={"ShipBlu"}>ShipBlu</MenuItem>
                  <MenuItem value={"Bosta"}>Bosta</MenuItem>
                  <MenuItem value={"Fincart"}>Fincart</MenuItem>
                </MainInput>}
                <MainInput
                  sx={{ marginInlineEnd: 2, minWidth: "50vw" }}
                  autoFocus
                  value={inboundItemText}
                  label="Item or Order Id"
                  onChange={({ target }) => handleParseInput((target.value))}
                  onKeyDown={(e) => {
                    if (e.key === 'Tab' || e.key === 'Enter') {
                      e.preventDefault();
                      handleGetInboundItem(e.currentTarget.value);
                    }
                  }}
                />
                <Button onClick={() => handleGetInboundItem()} sx={{ ...main_button, mt: 1 }}>Get Items</Button>
              </Box>
            </CardContent>)}
          </Card>
        </Box>
        <Box>
          {Object.values(inboundItems)?.map((item) => {
            return (
              <Card key={item._id} sx={{ mt: 1 }}>
                <CardContent>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={2} sm={1}>
                      <Avatar src={item.product.image} variant="rounded" />
                    </Grid>
                    <Grid item xs={10} sm={4}>
                      <Typography fontWeight={600}>{item.product.name}</Typography>
                      {(item.product.sku || item.product.externalId) && (
                        <Typography variant="body2" color="text.secondary">
                          {item.product.sku || item.product.externalId}
                        </Typography>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Button
                        fullWidth
                        onClick={() => handlePrintLabel(item.product, item.quantityReceived, item.product.vendor)}
                        sx={{ ...sec_button }}
                      >
                        Print Label
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <InboundFaultySplitFields
                        quantityReceived={item.quantityReceived}
                        faultyQuantity={item.faultyQuantity}
                        quantityMax={item.maxQuantity}
                        quantityMin={1}
                        onQuantityChange={(qty) => updateItemQuantity(qty, item._id)}
                        onFaultyChange={(qty) => updateItemFaultyQuantity(qty, item._id)}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            )
          })}
        </Box>
        {relatedOrder && <Box sx={{ ...centered_flex_box, mt: 3 }}>
          <Button onClick={() => navigate(`/ims/warehouse-staff/inbounds/rto/action/${relatedOrder._id}`)} disabled={isLoading || submitted} sx={{ ...main_button }}>{isLoading ? <CircularProgress color="white" /> : "Take Action on Order"}</Button>
        </Box>}
        <Box sx={{ ...centered_flex_box, mt: 3 }}>
          <Button onClick={handleSubmit} disabled={isLoading || submitted} sx={{ ...main_button }}>{isLoading ? <CircularProgress color="white" /> : "Receive All"}</Button>
        </Box>
      </Box>
      
      {/* Confirmation Dialog for Quantity > 100 */}
      <Dialog
        open={confirmDialogOpen}
        onClose={handleCancelQuantityUpdate}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Confirm Large Quantity
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You are about to receive {pendingQuantityUpdate.quantity} units. This is greater than 100. Are you sure this is correct?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelQuantityUpdate} sx={{ ...sec_button }}>
            Cancel
          </Button>
          <Button onClick={handleConfirmQuantityUpdate} sx={{ ...main_button }} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  isLoading: state?.records?.isLoading || state?.wait?.isLoading,
  token: state?.auth?.token,
  products: state?.records?.products,
  warehouse: state?.records?.warehouse
});

const mapDispatchToProps = { getProducts, getWarehouses, receiveInbound, downloadProductsQRS };

export default connect(mapStateToProps, mapDispatchToProps)(ReceiveInbounds);
